
import * as React from "react";
import {Api} from "../../../../lib/Api";
import $ from "jquery";

interface ISendProblemButtonProps {
    order: any
    setUrl: any
}

interface ISendProblemButtonState {
    openModal: boolean
    message: string
}


export default class SendProblemButton extends React.Component<ISendProblemButtonProps, ISendProblemButtonState>{

    constructor(props:ISendProblemButtonProps){
        super(props);
        this.state = {
            openModal: false,
            message: ''
        };
    }

    private sendMessage() {
        Api.call('/user/order/problemWithProfessional', {
            orderId: this.props.order.id,
            message: this.state.message
        }, (result) =>{
            $('#cancel_order_modal').modal('toggle');
            if ( document.querySelector('.modal-backdrop') !== null ) {
                $('.modal-backdrop').remove();
            }

            this.props.setUrl('/user/index');
        });
    }


    render() {

        const statuses = ['cancelled', 'completed'];
        if(statuses.includes(this.props.order.status.key)){
            return (<></>);
        }


        if(this.state.openModal) {
            setTimeout(() => {
                if ( document.querySelector('#problem_modal') !== null ) {
                    $('#problem_modal').modal({show:true});
                }

            }, 200);
        }

        let order = this.props.order;
        return (
            <>
                <div className = "row">
                    <div className = "col-md-12">
                        <button className="purple_btn" onClick={() => this.setState({openModal: true})}>A problem with the professional</button>
                    </div>
                </div>
                {
                    this.state.openModal &&
                    <div role="dialog" className="modal fade" id="problem_modal">
                        <div className="modal-dialog modal-md" role="document">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="modal_content edit-offer-box edit-order-box">

                                        <div className="form-row">
                                            <div className="col text-center">
                                                <h1>
                                                    What is your problem with the professional?
                                                </h1>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col sfc">
                                                <textarea className="s-form-control" rows={8} onChange={ (e) => this.setState({message: e.target.value}) } placeholder="your message"></textarea>
                                            </div>
                                        </div>

                                        <button className = "purple_btn" onClick={() => this.sendMessage()}>Send</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                }
            </>

        );
    }
}
